import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/family-space/max-strength-badge.png'
import _imports_1 from '@/assets/family-space/15-year-tag.webp'
import _imports_2 from '@/assets/icons/check-light-green.svg'
import _imports_3 from '@/assets/grass-wide.webp'


const _hoisted_1 = { class: "relative w-full" }
const _hoisted_2 = { class: "relative z-10 w-web-panel md:max-w-[95%] gap-4 flex p-10 bg-[#f5faf0] shadow-[8px_24px_34px_0_#a5a3a333] mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "max-w-[200px] flex flex-col gap-6 justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_4 = { class: "ml-auto max-w-[480px] flex flex-col gap-1" }
const _hoisted_5 = { class: "text-sm leading-loose text-primary-gray" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-5 h-5 mt-1.5"
}, null, -1)
const _hoisted_7 = { class: "text-sm leading-loose text-primary-gray" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 bottom-0 left-0 right-0 flex items-center z-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "w-full h-60"
  })
], -1)

import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'tagged-wedget',
  props: ["bulletPoints"],
  setup(__props) {

const props = __props;
const bulletPoints = computed(() => {
  return props?.bulletPoints;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bulletPoints.value, (point) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex gap-2.5",
            key: point
          }, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(point), 1)
          ]))
        }), 128))
      ])
    ]),
    _hoisted_8
  ]))
}
}

})